//@ts-strict-ignore
//For lack of a better name - The current 'LineDetailsPanel' is actually for the 'Items' tab. This one is for the 'Line Details' tab.
import React, { useContext } from 'react';
import { default as Form } from '../../../components/connectedForm';
import ConnectedFormContext from '../../../components/Context/ConnectedFormContext';

const LazySalesInvoiceLineWorkspace = React.lazy(() => import('../../salesLedger/SalesInvoiceLineWorkspace'));

const LineDetailsInvoices = ({ selectedLineId, ...workspaceProps }) => {
  const connectedForm = useContext(ConnectedFormContext);

  if (!selectedLineId) return null;

  const invoiceLineFilters = [
    {
      filterOperation: 'EQUALS',
      filterParameters: {
        field: 'salesOrderLine.id',
        value: selectedLineId,
      },
    },
  ];

  return (
    <Form.Fieldset cols={1}>
      <LazySalesInvoiceLineWorkspace
        embeddedView={true}
        predefinedFilters={invoiceLineFilters}
        viewScreenName="/Customers/InvoiceLine/Workspace/"
        allowView={false}
        noEdit={true}
        deferViewInitialize={!connectedForm.values?.id}
        {...workspaceProps}
      />
    </Form.Fieldset>
  );
};

export default LineDetailsInvoices;
